import styled from 'styled-components';

import { colors, remCalc, media, layout } from '@prisjakt/ui-base';

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${p => p.theme.lines.secondary};
  background-color: ${colors.white};
`;

export const ExpansionButton = styled.button`
  cursor: pointer;
  text-transform: uppercase;
  font-size: ${remCalc(14)};
  font-weight: bold;
  text-align: left;
  color: ${p => p.theme.text.callToAction};
  margin-left: 10px;
  height: 35px;
  flex: 1;
  justify-content: center;
`;

export const ArrowButton = styled.button`
  cursor: pointer;
  margin-right: 10px;
  height: 35px;
`;

export const Input = styled.input`
  width: 100%;
  font-style: italic;
  margin-bottom: 10px;
  border: 1px solid ${p => p.theme.lines.secondary};
  padding: 5px;
  outline: 0;

  ${media.mediumDown`
    margin-top: 5px;
  `};

  &:focus {
    border-color: ${colors.lightBlue2};
    box-shadow: inset 0 0 0 1px ${colors.lightBlue2};
  }
`;

export const InputWrapper = styled.div`
  padding: 0 10px;
`;

export const ExpandFilterButton = styled.div`
  padding: ${layout.spacing.xSmall} 0;
  display: flex;
  justify-content: flex-end;
`;
